import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
	transform(values: Array<any>, filter: any, properties?: string[]): Array<any> {
		if (properties?.length > 0) {
			return (values ?? []).filter((value) => get(value, properties) === filter);
		}
		return (values ?? []).filter((value) => value === filter);
	}
}
